<template>
  <div v-if="!isEmptyPromoType">
    <ShopMore
      v-if="isShopMoreEnabled"
      :url="url"
      :label="label"
    />
    <ShopMoreExtended
      v-else-if="isShopMoreExtendedEnabled"
      :url="url"
      :label="label"
    />
    <ShopMoreToast
      v-else-if="isShopMoreToastEnabled"
      :url="url"
      :label="label"
      :promo-code="promoCode"
      :price-type-text="priceTypeText"
    />
  </div>
</template>

<script setup>
/* istanbul ignore file */
import { computed } from 'vue';
import { usePromoType } from '@common-vue/media-card-large/src/modules/price';
import { useShopMore } from '@common-vue/media-card-large/src/modules/shop-more';
import { useBreadcrumbs, getCategoryUrlWithPromoPlug } from '@modules/breadcrumbs';
import { useProductPrice } from '@modules/price';
import { useExperiments } from '@composables/useExperiments';
import { useKillswitches } from '@modules/featureControl';
import { usePageData } from '@composables/usePageData';
import ShopMore from './ShopMore';
import ShopMoreExtended from './ShopMoreExtended';
import ShopMoreToast from './ShopMoreToast';

const { isOrigin, isSecondPDP } = usePageData();
const {
  experimentFlags: {
    isShopMoreStandardEnabled,
    isShopMoreExpandedEnabled,
  },
} = useExperiments();

const isPdpEntry = !isOrigin && !isSecondPDP;
const isNonPdpEntry = isOrigin;
const isSecondaryPdpEntry = isOrigin && isSecondPDP;

const isShopMoreEnabled = isShopMoreStandardEnabled && (isNonPdpEntry || isSecondaryPdpEntry);
const isShopMoreExtendedEnabled = isShopMoreExpandedEnabled && (isNonPdpEntry || isSecondaryPdpEntry);
const isShopMoreToastEnabled = isPdpEntry;

const selectedPrice = useProductPrice();
const { homeCategory } = useBreadcrumbs();
const { killswitches: { isPDPEnhancementXEnabled } } = useKillswitches();

const priceTypeText = computed(() => selectedPrice.value?.priceType?.text || '');
const promoEventBadgeUrl = computed(() => selectedPrice.value?.priceType?.promoEventBadgeUrl || '');
const priceFlags = computed(() => selectedPrice.value?.flags || {});
const promoCode = computed(() => selectedPrice.value?.lowestSalePriceTier?.promoCode || '');
const promoCodePromotionBadgeUrl = computed(() => selectedPrice.value?.lowestSalePriceTier?.promoEventBadgeUrl);
const promoUrl = computed(() => (promoCode.value ? promoCodePromotionBadgeUrl : promoEventBadgeUrl));

const categoryUrlWithPromoPlug = getCategoryUrlWithPromoPlug(homeCategory.url);
const { promoType, isEmptyPromoType } = usePromoType({ priceTypeText, priceFlags });
const { label, url: uiGeneratedUrl } = useShopMore({
  promoType,
  promoCode,
  categoryUrlWithPromoPlug,
});
const url = isPDPEnhancementXEnabled ? promoUrl.value : uiGeneratedUrl;
</script>
